import { render, staticRenderFns } from "./VrshipchartLibrarydetails.vue?vue&type=template&id=b214524a&scoped=true&"
import script from "./VrshipchartLibrarydetails.vue?vue&type=script&lang=js&"
export * from "./VrshipchartLibrarydetails.vue?vue&type=script&lang=js&"
import style0 from "./VrshipchartLibrarydetails.vue?vue&type=style&index=0&id=b214524a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b214524a",
  null
  
)

export default component.exports